import { useAtomValue } from "jotai";
import { createElement } from "react";
import * as AllModals from "src/modals";
import { modalsAtom } from "./store/atoms";

export const Modals = () => {
  const modals = useAtomValue(modalsAtom);

  return (
    <>
      {modals.map((modal) => {
        // Name, not index: closing the front modal must not remount the one behind it.
        return createElement(AllModals[modal], { key: modal });
      })}
    </>
  );
};
